export default __webpack_public_path__ + "static/media/image__left.cb6a9b21.png";